import React, { Component } from "react";
import IGetVendorAddressesDTO from "../../../models/DTO/IGetVendorAddressesDTO";
import IOnGetVendorAddressesDTO from "../../../models/DTO/IOnGetVendorAddressesDTO";
import IAddress from "../../../models/IAddress";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import { LoadingResults } from "../../shared/LoadingResults/LoadingResults";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./OrderAddressSidebar.scss";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";

type Props = {
    address?: IAddress;
    orderModel: IOrder;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    socket: Socket;
    cancel: (refreshData?: boolean) => void;
    updateShipTo: (e: any, addresses: IAddress[]) => void;
};

type State = {
    addresses: IAddress[];
    isLoading: boolean;
};

class OrderAddressSidebar extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        addresses: [],
        isLoading: true,
    };

    constructor(props: any) {
        super(props);

        this.sockets = [{ endpoint: EndpointsEnum.AddressOnGetVendorAddresses, fn: this.onGetVendorAddresses }];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        this.getVendorAddresses();
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getVendorAddresses = () => {
        const payload: IGetVendorAddressesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
            onlyNonAssignedAddresses: true,
        };

        this.props.socket.emit("getVendorAddresses", payload);

        this.setState({
            isLoading: true,
        });
    };

    onGetVendorAddresses = (data: IOnGetVendorAddressesDTO) => {
        this.setState({
            addresses: data.addresses,
            isLoading: false,
        });
    };

    selectAddress = (address: IAddress) => {
        const e = {
            target: {
                name: "ship_to_id",
                value: address.id,
            },
        };

        this.props.updateShipTo(e, this.state.addresses);
        this.props.cancel(false);
    };

    getAddressRows = () => {
        if (this.state.isLoading) {
            return <LoadingResults />;
        } else {
            return this.state.addresses.map((address) => {
                return (
                    <div key={address.guid} className={"mb-5"}>
                        {address.is_vendor_main_ship_to ? (
                            <OwLabel className={"text-primary"} isBold={true} title={"default_ship_to"} />
                        ) : null}
                        {address.catalog_id || address.price_group_id ? (
                            <div>
                                <OwLabel title={"catalog_price_group"} className={"me-1 text-primary"} postText={":"} />
                                {`${address.Catalog?.name} - ${address.Price_Group?.value}`}
                            </div>
                        ) : null}
                        <div className={"d-flex"}>
                            <div className={"text-center me-2"}>
                                {this.props.supplierModel.has_google_maps ? <OwGoogleStaticMap address={address} size={"180x180"} /> : null}
                                <OwButton
                                    className={"btn-primary mt-2"}
                                    title={"select"}
                                    fn={(e: any) => {
                                        this.selectAddress(address);
                                    }}
                                />
                            </div>
                            <AddressDisplay
                                address={address}
                                showName={true}
                                showCompanyName={true}
                                showPhone={true}
                                hideMobile={true}
                                hideEmail={true}
                            />
                        </div>
                    </div>
                );
            });
        }
    };

    render() {
        return (
            <div className="OrderAddressSidebar p-2">
                <div className={"h-7r"}>
                    <div className="text-end">
                        <OwButton
                            className={"btn-sm btn-danger"}
                            centerIconClass={"far fa-times"}
                            fn={() => {
                                this.props.cancel(false);
                            }}
                        />
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-building"} title={"address"} />
                    <hr />
                </div>

                <div>{this.getAddressRows()}</div>
            </div>
        );
    }
}

export default OrderAddressSidebar;
